/** Locales for which react-aria will include support */
export const availableLocales = ["en-US", "en-GB", "en-ZA", "et-EE", "ja-JP", "id-ID", "th-TH", "fr-TN", "fi-FI"];
